import { Modal } from 'bootstrap';
import TabTrap from '../utils/tabTrap';

const HeaderTakeoverMenu = (header, opts) => {
    // Get menu toggle buttons and their associated submenus and data
    const takeover = document.querySelector(opts.takeoverSelector);

    if (!takeover) return;

    const hamburgerButton = header.querySelector(opts.hamburgerSelector);
    const submenuButtons = takeover.querySelectorAll(opts.buttonSelector);
    const submenuData = Array.from(submenuButtons).map(button => {
        const parent = button.closest('ul');
        const panel = takeover.querySelector('.visual-menu ul[data-menu="' + button.getAttribute('data-menu') + '"]');
        const panelTabTrap = new TabTrap(panel);
        return {
            button,
            parent,
            panel,
            panelTabTrap,
            depth: +button.getAttribute('data-depth') || 0,
            isBackButton: button.classList.contains(opts.backButtonClass) || false,
        };
    });
    submenuData.forEach(data => {
        data.panelTabTrap.update();
    })

    const takeoverModal = new Modal(takeover, { focus: false});
    hamburgerButton.addEventListener('click', () => {
        takeoverModal.toggle();
    });

    // Hide modal when clicking outside the visual menu area
    const modalContent = takeover.querySelector('.modal-content');
    modalContent.addEventListener('click', (event) => {
        if (event.target === event.currentTarget) {
            takeoverModal.toggle();

        }
    });

    let curDepth = 0;
    submenuData.forEach(data => {
        data.button.addEventListener('click', (event) => {
            event.preventDefault();

            const button = data.button;
            
            let submenus = [];
            
            let temp_depth = data.depth+1;
            while (temp_depth < 3) {
                submenus = [...submenus, ...takeover.querySelectorAll(`.visual-menu ul[data-depth="${temp_depth}"]`)];
                temp_depth++;
            }
            let isOpening = false;
            if (!data.isBackButton) {
                isOpening = button.classList.toggle(opts.activeClass);
            }
            let topLevelMenuChange = false;
            
            // Toggle the transition depending on whether the SUBMENU LEVEL being opened is already open
            if (isOpening && data.depth < curDepth) {
                // If the 3rd submenu is open and we click a top-level menu item
                if (data.depth + 2 <= curDepth) {
                    topLevelMenuChange = true;
                }
                submenus.forEach(submenu => {
                    if (!topLevelMenuChange) {
                        submenu.classList.add(opts.noTransitionClass);
                    } else {
                        if (data.panel.contains(submenu)) {
                            submenu.classList.add(opts.noTransitionClass);
                        } else {
                            submenu.classList.remove(opts.noTransitionClass);
                        }
                    }
                });
            } else {
                submenus.forEach(submenu => {
                    submenu.classList.remove(opts.noTransitionClass);
                });
            }

            // Close all other submenus at the same level
            submenus.forEach(submenu => {
                submenu.classList.remove(opts.activeClass)
            });
            const submenuButtons = takeover.querySelectorAll(opts.buttonSelector);
            submenuButtons.forEach(btn => {
                if (btn === button) return;
                if (btn.dataset.depth < data.depth) return;
                btn.classList.remove(opts.activeClass);
            });

            // Update the active state of the panel
            if (data.panel && data.panel.classList.contains(opts.submenuClass)) {
                if (isOpening) {
                    data.panel.classList.add(opts.activeClass);
                    data.panelTabTrap.on();
                    curDepth = data.depth + 1;
                } else {
                    data.panel.classList.remove(opts.activeClass);
                    data.panelTabTrap.off();
                    curDepth = data.depth;
                }
            }
        });
    });
}

export default HeaderTakeoverMenu;